import FormattedMessage from 'I18n/components/FormattedMessage';
import { Inbound25CopyChange } from '../../../common/i18n/CopyChangeComponents';
import { jsx as _jsx } from "react/jsx-runtime";
export const SuiteCardSubheading = ({
  productLevel
}) => {
  if (productLevel === 'STARTER') return /*#__PURE__*/_jsx(Inbound25CopyChange, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "merchCards.suiteTile.starterCard.description"
    })
  });
  if (productLevel === 'PROFESSIONAL') return /*#__PURE__*/_jsx(Inbound25CopyChange, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "merchCards.suiteTile.professionalCard.description"
    })
  });
  if (productLevel === 'ENTERPRISE') return /*#__PURE__*/_jsx(Inbound25CopyChange, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "merchCards.suiteTile.enterpriseCard.description"
    })
  });
  return null;
};